<template>
  <BaseQuery>
    <BaseQueryLeft :span="2">
      <el-button icon="el-icon-plus" :size="formSize" type="primary" @click="add">
        新增
      </el-button>
    </BaseQueryLeft>
    <BaseQueryRight :span="22">
      <el-form :model="form" :inline="true" :size="formSize">
        <el-form-item label="渠道:">
          <el-input v-model="form.nickname" placeholder="请输入渠道名称查询" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </BaseQueryRight>
  </BaseQuery>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "QueryForm",
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    mediaList: {
      type: Array,
      default: () => [],
    },
    channelList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {},
      formSize: "small",
    };
  },
  computed: {
    ...mapState("app", ["cityList"]),
  },
  watch: {
    value: {
      handler(val) {
        this.form = val;
      },
      deep: true,
      immediate: true,
    },
    form: {
      handler(val) {
        this.$emit("input", val);
      },
      deep: true,
    },
  },
  methods: {
    search() {
      this.$parent.page.page = 1;
      this.$emit("search");
    },
    add() {
      this.$router.push({
        name: "ChannelCreate",
        params: {
          type: "add",
        },
      });
    },
  },
};
</script>
